import {Component, computed, input} from '@angular/core';
import {FloatLabel} from 'primeng/floatlabel';
import {InputText} from 'primeng/inputtext';
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslateModule} from "@ngx-translate/core";
import {MessageModule} from 'primeng/message';

@Component({
  selector: 'elcia-text-input',
  imports: [
    FloatLabel,
    InputText,
    TranslateModule,
    MessageModule,
    ReactiveFormsModule,
  ],
  templateUrl: './text-input.html',
  styleUrl: './text-input.scss'
})
export class TextInput {
  label = input.required<string>();
  control = input.required<FormControl<string | null>>();
  type = input<string>('text');
  autocomplete = input<string>('off');
  isRequired = computed(() => this.control().hasValidator(Validators.required));
}
